import { render, staticRenderFns } from "./WidgetMyAccountLinks.vue?vue&type=template&id=3257b870&"
import script from "./WidgetMyAccountLinks.vue?vue&type=script&lang=js&"
export * from "./WidgetMyAccountLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports